import {PixelRatio, Platform, View} from 'react-native';
import Styles from 'src/components/Styles';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import AVFormattedCurrency from 'src/components/elements/AVFormattedCurrency';
import {Key} from 'react';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import PersonRedesign from 'src/components/img/svg/PersonRedesign';
import RewardRedesign from 'src/components/img/svg/RewardRedesign';
import AccountStore from 'src/stores/AccountStore';
import SnackDetailsRedesign from '../../../img/svg/SnackDetailsRedesign';

export function getBalanceStripeIcon(): JSX.Element {
  return <PersonRedesign size={Styles.Heights.h2} />;
}

export function getBalanceRollOverIcon(): JSX.Element {
  return <RewardRedesign size={Styles.Heights.h2} />;
}

export function balanceItemRoundedBtnColorDescriptor(): string {
  return Styles.Colors.CompanyKitchen.green;
}

export function balanceAmountStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    fontFamily: Styles.FontFamily.latoRegular,
    fontWeight: '700',
    fontSize: Styles.Fonts.f1,
  };
}

export function balanceTypeStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    fontFamily: Styles.FontFamily.latoRegular,
    fontSize: Styles.Fonts.f1,
    color: Styles.tabBarTextColor,
  };
}

export function getBalanceItemStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    container: {
      justifyContent: 'flex-start',
      paddingHorizontal: Styles.Spacing.m3,
      flex: 1,
      borderBottomColor: Styles.lightGray,
      width: '100%',
      alignItems: 'center',
      paddingVertical: Styles.Spacing.m3,
      flexDirection: 'row',
    },
    button: {
      right: Styles.Spacing.m3,
      position: 'absolute',
      top: Styles.Spacing.m2 + Styles.Spacing.m1,
      borderWidth: 2,
    },
    fundButtonText: {
      paddingHorizontal: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.latoRegular,
      color: Styles.Colors.CompanyKitchen.black,
    },
    balanceContainer: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      paddingHorizontal: Styles.Spacing.m2,
    },
    totalText: {
      color: Styles.tabBarTextColor,
      fontSize: Styles.Spacing.m3 + Styles.Spacing.m1,
      fontWeight: '700',
    },
    promoContainer: {
      backgroundColor: Styles.tabBarBackgroundColor,
      flex: 1,
    },
  };
}

export function SaleDetailModMaxFontSizeMultipleDescriptor(): number {
  return Styles.FontSizeMultiplier.maxfm8;
}

export function getFundButtonForBalanceScreen(fundBtnCallback): JSX.Element {
  return (
    <RoundedButton
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={Localized.Labels.fund_account}
      aria-label={Localized.Labels.fund_account}
      role="button"
      onPress={fundBtnCallback}
      buttonType={ButtonType.outline}
      containerStyle={getBalanceItemStyleDescriptor().button}
      color={balanceItemRoundedBtnColorDescriptor()}
      textStyle={getBalanceItemStyleDescriptor().fundButtonText}
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
      text={Localized.Labels.fund}
      testID="qa_btn_Fund"
    />
  );
}
export function promoCreditAmount(styles, props) {
  return (
    <View style={styles.rightViewCpCk}>
      <AVFormattedCurrency
        style={[promoCreditdetailAccountFndgTxt()]}
        value={props.detail.Amount}
        accessibilityLabel={`$${props.detail.Amount}`}
        aria-label={`$${props.detail.Amount}`}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
        currency={AccountStore.getCurrency()}
      />
    </View>
  );
}

export function SaleDetailRowStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    alignItems: 'center',
    backgroundColor: Styles.Colors.Canteen.lightGray,
    flexDirection: 'row',
    paddingVertical: Styles.Spacing.m0,
    paddingHorizontal: Styles.Spacing.m2,
    justifyContent: 'space-between',
    width: '90%',
  };
}

export function SaleDetailNameStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    flex: 1,
    fontSize: Styles.Fonts.f1,
    marginRight: Styles.Spacing.m2,
    color: Styles.darkColor,
    flexWrap: 'wrap',
  };
}

export function SaleDetailSupLblMaxFontSizeMultipleDescriptor(): number {
  return Styles.FontSizeMultiplier.maxfm10;
}

export function SaleDetailAmtStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    fontSize: Styles.Fonts.f1,
    color: Styles.darkColor,
    alignItems: 'flex-end',
    right: -32,
    fontFamily: Styles.FontFamily.latoRegular,
  };
}

export function SaleDetailModNameStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    flex: 1,
    marginRight: Styles.Spacing.m2,
    marginVertical: 10,
    flexDirection: 'row',
    maxWidth: '70%',
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.latoRegular,
    color: Styles.lightGray,
  };
}

export function PurchaseDetailFormateedDateStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.latoRegular,
    color: Styles.darkColor,
    fontWeight: '400',
  };
}

export function getDashedStyleDescriptor(): {
  [index: string]: {[index: string]: number};
} {
  return {
    dashStyle: {
      dashLength: PixelRatio.roundToNearestPixel(2),
      dashThickness: PixelRatio.roundToNearestPixel(2),
    },
  };
}

export function getDashColor(): {
  [index: string]: {[index: string]: string};
} {
  return {
    dashStyle: {
      dashColor: '#999',
    },
  };
}

export function getSaleAmountTextUI(
  modPrice: number,
  saleCurrency: string,
  modifierStyle: unknown,
  modId: Key,
) {
  return (
    <AVText
      key={modId}
      style={modifierStyle}
      accessible
      testID="qa_Receipt.ModifierPrice_txt"
      nativeID="qa_Receipt.ModifierPrice_txt"
    >
      +
      <AVFormattedCurrency
        accessibilityLabel={`+$${modPrice}`}
        aria-label={`+$${modPrice}`}
        style={modifierStyle}
        value={modPrice}
        currency={saleCurrency}
      />
    </AVText>
  );
}

export function fundingdetailTrans(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.lightGray,
    fontSize: Styles.Fonts.f0,
    fontFamily: Styles.FontFamily.latoRegular,
  };
}

export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    remainingBalance: {},
    orderStatus: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.latoRegular,
    },
    orderStatusValue: {
      fontSize: Styles.Fonts.f1,
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: '400',
    },
    pickupTime: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.latoRegular,
      marginTop: Styles.Spacing.m1 + 4,
    },
    instructions: {
      marginTop: Styles.Spacing.m2,
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f8,
      fontFamily: Styles.FontFamily.latoRegular,
      fontStyle: 'italic',
    },
    location: {
      marginTop: Styles.Spacing.m3,
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: 'bold',
    },
    pickupDate: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.latoRegular,
      marginTop: Styles.Spacing.m2,
    },
    points: {
      fontSize: Styles.Fonts.f1,
      color: Styles.Colors.PayNew.success,
      fontWeight: '700',
      fontStyle: 'normal',
    },
    dashStyleBorder: {
      borderRadius: 100,
      height: PixelRatio.roundToNearestPixel(2),
      marginBottom: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      overflow: 'hidden',
      width: '100%',
    },
    sectionMarginLeft: {
      marginLeft: -4,
    },
    summaryTopMargin: {
      marginTop: null,
    },
    totalLabel: {
      marginBottom: Styles.Spacing.m1,
      marginTop: -1 * Styles.Spacing.m1,
      color: Styles.darkColor,
      fontSize: 24,
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: '700',
    },
    modifierAmount: {
      color: Styles.lightGray,
      fontFamily: Styles.FontFamily.latoRegular,
      fontSize: Styles.Fonts.f1,
    },
    sectionMarginLeftWithZero: {
      marginLeft: 0,
    },
    sectionMarginRightWithZero: {
      marginRight: null,
    },
    shareIconColor: {
      color: Styles.white,
    },
    summaryExtra: {
      marginBottom: Styles.Spacing.m1,
    },
    rowReverse: {
      flexDirection: 'row-reverse',
      flexWrap: 'wrap',
    },
    buttonSpacing: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
}
export function fundingDetailTotal(): {
  [index: string]: number | string;
} {
  return {
    fontWeight: '300',
    color: Styles.black,
    fontSize: Styles.Fonts.f3,
    fontFamily: Styles.FontFamily.latoRegular,
    marginBottom: Styles.Spacing.m1,
    marginTop: -1 * Styles.Spacing.m1,
  };
}
export function fundingdetailAccountFndgTxt() {
  return {
    fontFamily: Styles.FontFamily.latoRegular,
    fontSize: Styles.Fonts.f1,
  };
}

export function promoCreditdetailAccountFndgTxt(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.tabBarTextColor,
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.robotoRegular,
    fontWeight: '400',
  };
}
export function promoCreditTotalText() {
  return Localized.Buttons.your_total;
}

export function getActionBtns(
  handleDone: () => void,
  shareReceipt: () => void,
) {
  return (
    <View
      style={[
        Styles.Style.row,
        {
          bottom: 0,
          position: 'absolute',
          right: Styles.Spacing.m3,
          left: Styles.Spacing.m3,
        },
      ]}
    >
      <RoundedButton
        accessible={true}
        accessibilityLabel={Localized.Labels.share}
        accessibilityRole="button"
        aria-label={Localized.Labels.share}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
        buttonType={ButtonType.normal}
        role="button"
        onPress={shareReceipt}
        containerStyle={[
          Styles.Style.actionButton,
          getStyleDescriptor().buttonSpacing,
          {marginRight: Styles.Spacing.m3},
        ]}
        textStyle={Styles.Style.actionButtonText}
        icon={
          <FontAwesome5Pro
            name={'share-alt'}
            color={Styles.white}
            size={Styles.Fonts.f1}
            style={{
              marginEnd: Styles.Spacing.m2,
            }}
            solid
          />
        }
        text={Localized.Labels.share}
        testID="qa_Receipt.Share_Btn"
        nativeID="qa_Receipt.Share_Btn"
      />
      <RoundedButton
        buttonType={ButtonType.normal}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
        onPress={handleDone}
        containerStyle={[
          Styles.Style.actionButton,
          getStyleDescriptor().buttonSpacing,
        ]}
        textStyle={Styles.Style.actionButtonText}
        text={Localized.Buttons.done}
        accessible={true}
        accessibilityLabel={Localized.Buttons.done}
        accessibilityRole="button"
        aria-label={Localized.Buttons.done}
        role="button"
        testID="qa_Receipt.Done_Btn"
        nativeID="qa_Receipt.Done_Btn"
      />
    </View>
  );
}

export function paydescription() {
  return null;
}
export function paystatus() {
  return null;
}
export function payPrefixTxt() {
  return '';
}

export function payLocationAddr() {
  return null;
}

export function paySnackContainer() {
  return null;
}

export function PurchaseDetailDateFormatStyleDescriptor(): string {
  return 'MMMM D, YYYY [at] h:mm A';
}

export function paySnackRow() {
  return null;
}

export function giftIconSnack() {
  return <SnackDetailsRedesign fill={'#025D33'} />;
  // return <SnackGiftIcon />;
}

export function payBalanceType(styles) {
  return styles.paybalanceTypeDisplay;
}
export function payDteDisplay(styles) {
  return styles.payDteDisplay;
}

export function fundingDetailDate(): {
  [index: string]: number | string;
} {
  return {
    marginBottom: Styles.Spacing.m3,
    fontSize: Styles.Fonts.f0,
    fontFamily: Styles.FontFamily.latoRegular,
  };
}

export function PurchaseDetailIdStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    marginTop: Styles.Spacing.m1,
    marginBottom: Styles.Spacing.m2,
    marginRight: Styles.Spacing.m3,
    color: Styles.lightGray,
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.latoRegular,
  };
}

export function PurchaseDetailSubtotalStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.lightGray,
    fontFamily: Styles.FontFamily.latoRegular,
    fontSize: Styles.Fonts.f1,
    marginRight: Styles.Spacing.m3,
  };
}

export function PurchaseDetailDepositStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.lightGray,
    fontSize: Styles.Fonts.f1,
    marginBottom: Styles.Spacing.m1,
    fontFamily: Styles.FontFamily.latoRegular,
  };
}

export function PurchaseDetailtaxStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.lightGray,
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.latoRegular,
    marginRight: Styles.Spacing.m3,
  };
}

export function PurchaseDetailDiscountStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    fontFamily: Styles.FontFamily.latoRegular,
    color: Styles.positiveColor,
    fontSize: Styles.Fonts.f1,
  };
}
export function PurchaseHistorySubtotalStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.lightGray,
    marginBottom: Styles.Spacing.m1,
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.latoRegular,
  };
}
export function rightViewStyle() {
  return null;
}

export function fundingDetailAccount(styles, props) {
  return (
    <View style={styles.rightView}>
      <AVFormattedCurrency
        style={[fundingdetailAccountFndgTxt()]}
        value={props.detail.Amount}
        accessibilityLabel={`$${props.detail.Amount}`}
        aria-label={`$${props.detail.Amount}`}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
        currency={AccountStore.getCurrency()}
      />
    </View>
  );
}
export function payOrderNumber() {
  return null;
}
export function payDashedLine() {
  return '#999';
}

export function leftViewStyle() {
  return {justifyContent: 'flex-start', alignItems: 'flex-start'};
}
export function fundingDetailContainer() {
  return {flex: 1, flexDirection: 'row'};
}
export function redemptionDetailContainer() {
  return {flex: 1, flexDirection: 'row'};
}
export function fundingHeaderTitle() {
  return Localized.Labels.funding_summary;
}

export function historyEmailReceiptBtn(
  handleEmailReceipt,
  styles,
  detailID?: string,
  isUSACheck?: string,
  isHistory?: boolean,
) {
  return (
    isHistory && (
      <>
        <RoundedAppButton
          buttonType={RoundedAppButtonType.Solid}
          titleText={Localized.Buttons.email_receipts}
          onPress={() => {
            handleEmailReceipt(detailID || null);
          }}
          textStyle={{
            fontWeight: Platform.OS === 'android' ? 'bold' : '700',
            fontFamily: Styles.FontFamily.latoRegular,
            fontSize: Styles.Fonts.f1,
            color: Styles.white,
            flex: 1,
            textAlign: 'center',
          }}
          buttonViewStyle={{
            paddingHorizontal: 24,
            paddingVertical: 12,
            minHeight: 42,
          }}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          buttonContainerStyle={{
            right: Styles.Spacing.m3,
            left: Styles.Spacing.m3,
            bottom: Styles.Spacing.m3,
            position: 'absolute',
          }}
          aria-label={Localized.Buttons.email_receipts}
          testID="qa_Receipt.Share_Btn"
        />
      </>
    )
  );
}
export function getEUDigitalRecipts() {
  return null;
}

export function payOrderStatus() {
  return null;
}

export default {
  getStyleDescriptor,
  getDashedStyleDescriptor,
  getDashColor,
  getActionBtns,
  paySnackContainer,
  getFundButtonForBalanceScreen,
  fundingdetailAccountFndgTxt,
  paySnackRow,
  PurchaseHistorySubtotalStyleDescriptor,
  historyEmailReceiptBtn,
  getEUDigitalRecipts,
  fundingDetailContainer,
  redemptionDetailContainer,
  balanceItemRoundedBtnColorDescriptor,
  balanceAmountStyleDescriptor,
  fundingDetailTotal,
  balanceTypeStyleDescriptor,
  getBalanceItemStyleDescriptor,
  leftViewStyle,
  paydescription,
  SaleDetailModMaxFontSizeMultipleDescriptor,
  SaleDetailRowStyleDescriptor,
  SaleDetailSupLblMaxFontSizeMultipleDescriptor,
  SaleDetailNameStyleDescriptor,
  SaleDetailAmtStyleDescriptor,
  payDashedLine,
  SaleDetailModNameStyleDescriptor,
  rightViewStyle,
  payBalanceType,
  payDteDisplay,
  PurchaseDetailIdStyleDescriptor,
  PurchaseDetailSubtotalStyleDescriptor,
  paystatus,
  PurchaseDetailDepositStyleDescriptor,
  PurchaseDetailtaxStyleDescriptor,
  fundingdetailTrans,
  fundingDetailAccount,
  payPrefixTxt,
  payOrderNumber,
  payOrderStatus,
  promoCreditTotalText,
  fundingDetailDate,
  getSaleAmountTextUI,
  getBalanceStripeIcon,
  fundingHeaderTitle,
  getBalanceRollOverIcon,
  payLocationAddr,
  giftIconSnack,
  promoCreditAmount,
  PurchaseDetailFormateedDateStyleDescriptor,
  PurchaseDetailDateFormatStyleDescriptor,
  PurchaseDetailDiscountStyleDescriptor,
};
